<template>
  <div class="home">
    <div class="bg bg1"></div>
    <div class="top">

      <div class="box">

        <div class="headportrait">
          <img v-if="account.photo" :src="account.photo" alt="">
          <img v-else src="./assets/img/img.jpg" alt="">
        </div>

        <div class="information">
          <p>{{account.nickname}}</p>
          <div class="tel">{{account.account}}</div>
        </div>
        <div class="badgebox">
          <router-link v-for="(v,k) in honorInfo" v-bind:key="k" v-if="v.id==account.honor" :to="{ name: 'seal' }" class="badge" :class="['app-seal'+account.honor]">{{v.title}}</router-link>
          <!-- <router-link :to="{ name: 'seal' }" class="badge app-seal1">金印章</router-link> -->
          <!-- <router-link :to="{ name: 'seal' }" class="badge app-seal2">银印章</router-link> -->
          <!-- <router-link :to="{ name: 'seal' }" class="badge app-seal3">铜印章</router-link> -->
          <!-- <router-link :to="{ name: 'seal' }" class="badge app-seal4">铁印章</router-link> -->
        </div>


        <div class="money weui-flex">
            <router-link :to="{ name: 'balance' }" class="weui-flex__item">
              <div class="num">¥{{account.all_money}}</div>
              <p>余额</p>
            </router-link>
            <router-link :to="{ name: 'integral' }" class="weui-flex__item">
              <div class="num">{{account.point}}</div>
              <p>积分</p>
            </router-link>
            <router-link :to="{ name: 'mycard'}" class="weui-flex__item">
              <div class="num">{{coupon}}</div>
              <p>券盒</p>
            </router-link>
        </div>
      </div>
    </div>


    <div class="alinklist weui-cells">
        <router-link :to="{ name: 'myorder' , query: { status: 0 }}" class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
                <p>我的订单</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <router-link :to="{ name: 'message'}" class="weui-cell weui-cell_access">
            <div class="weui-cell__bd">
                <p>消息中心</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <router-link :to="{ name: 'parcel'}" class="weui-cell weui-cell_access">
            <div class="weui-cell__bd">
                <p>丰巢留言</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <router-link :to="{ name: 'help'}" class="weui-cell weui-cell_access">
            <div class="weui-cell__bd">
                <p>帮助中心</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <!-- <div @click="logout()" class="weui-cell weui-cell_access">
            <div class="weui-cell__bd">
                <p>退出登录</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </div> -->
    </div>
  </div>
</template>
<script>
  export default{
    data(){
      return{
        account:{nickname:"***",account:"***********",point:0,honor:0,money:0.00,money_company:0.00},
        honorInfo:[{ id: 0, title: '印章租赁'}],
        coupon:0
      }
    },
    mounted() {
      this.getAccount();
      this.getHonorInfo();
      this.getAccountCoupon();
    },
    methods:{
      // logout(){
      //   let vm = this;
      //   vm.ajax("logout", "post", '', e => {
      //     vm.$router.replace({name:'login'})
      //   })
      // },
      getAccount(){
        let vm = this;
        vm.ajax("account", "get", '', e => {
          vm.account = e.data;
          let all_money = vm.account.money + vm.account.money_company;
          vm.account.all_money = all_money.toFixed(2)
        })
      },
      getHonorInfo(){
        let vm = this;
        vm.ajax("account/honor", "get", '', e => {
          vm.honorInfo = e.data.list;
          vm.honorInfo.push({ id: 0, title: '印章租赁'})
        })
      },
      getAccountCoupon(){
        let vm = this;
        vm.ajax("account/coupon", "get", '', e => {
          if(e.data.enable && e.data.enable.length > 0)
          vm.coupon = e.data.enable.length;
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/home.vue